import {
  SCHOOL_SET,
  SCHOOL_LIST,
} from '../mutation-types';

import Vue from 'vue';
import store from 'store';

const state = {
  school: null,
  schoolList: null,
};

const mutations = {
  [SCHOOL_SET] (state, school) {
    store.set('school', school);
    Vue.set(state, 'school', school);
  },
  [SCHOOL_LIST] (state, schoolList) {
    store.set('schoolList', schoolList);
    Vue.set(state, 'schoolList', schoolList);
  },
};

Vue.set(state, 'school', store.get('school') || {
  id: 1,
  name: 'University of Illinois at Urbana-Champaign',
  abbr: 'UIUC',
});

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/school.js